import { render } from "./NewClientSkuMaster.vue?vue&type=template&id=f4dfc6de"
import script from "./NewClientSkuMaster.vue?vue&type=script&lang=js"
export * from "./NewClientSkuMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__